import React from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';
import Modal from 'components/lib/Modal';

const DiscardModalBody = styled.div`
  padding: 0 0 20px;
`;

const DiscardModalDescription = styled.div`
  font-size: 14px;
  color: var(--text-secondary);
`;

const DiscardButton = styled(Button)`
  min-width: 110px;
  border-radius: 4px;
`;

const KeepEditingButton = styled(DiscardButton)`
  width: 145px;
`;

type Props = {
  open: boolean;
  onDiscard: () => void;
  onKeepEditing: () => void;
};

const DiscardChangesModal = ({ open, onDiscard, onKeepEditing }: Props) => {
  return (
    <Modal
      centered
      open={open}
      className="compact"
      title="Discard Changes?"
      onCancel={onKeepEditing}
      footer={[
        <DiscardButton key="discard" type="primary" onClick={onDiscard}>
          Discard
        </DiscardButton>,
        <KeepEditingButton key="keep-editing" onClick={onKeepEditing}>
          Keep Editing
        </KeepEditingButton>,
      ]}
    >
      <DiscardModalBody>
        <DiscardModalDescription>
          Changing to a different tab without saving first will discard your current changes.
        </DiscardModalDescription>
      </DiscardModalBody>
    </Modal>
  );
};

export default DiscardChangesModal;
